<template>
  <v-card style="width: 100%">
    <v-card-title>Agenda de promoción</v-card-title>
    <v-card-text>
      <v-row>
        <v-col xs="6" sm="6">
          <v-switch v-model="form.recurrente" label="Semanal/Recurrente" />
        </v-col>
        <v-col xs="6" sm="6">
          <v-switch v-model="form.diario" label="Diario" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="font-weight-bold">
          Agregue un rango de horas
        </v-col>
        <v-col cols="6">
          <v-dialog
            ref="dialog1"
            v-model="modal_hora_inicio"
            :return-value.sync="form.hora_inicio"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="form.hora_inicio"
                label="Hora de inicio"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="modal_hora_inicio"
              v-model="form.hora_inicio"
              full-width
              format="24hr"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal_hora_inicio = false">
                Cancelar
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.dialog1.save(form.hora_inicio)"
              >
                OK
              </v-btn>
            </v-time-picker>
          </v-dialog>
        </v-col>
        <v-col cols="6">
          <v-dialog
            ref="dialog2"
            v-model="modal_hora_fin"
            :return-value.sync="form.hora_fin"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="form.hora_fin"
                label="Hora final"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="modal_hora_fin"
              v-model="form.hora_fin"
              full-width
              format="24hr"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal_hora_fin = false">
                Cancelar
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.dialog2.save(form.hora_fin)"
              >
                OK
              </v-btn>
            </v-time-picker>
          </v-dialog>
        </v-col>
      </v-row>
      <v-row v-if="!form.recurrente">
        <v-col cols="12" sm="6" md="6">
          <v-dialog
            ref="dialog3"
            v-model="modal_fecha_inicio"
            :return-value.sync="form.fecha_inicio"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="form.fecha_inicio"
                label="Fecha inicio"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="form.fecha_inicio" scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal_fecha_inicio = false">
                Cancelar
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.dialog3.save(form.fecha_inicio)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-dialog
            ref="dialog4"
            v-model="modal_fecha_fin"
            :return-value.sync="form.fecha_fin"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="form.fecha_fin"
                label="Fecha fin"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="form.fecha_fin" scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal_fecha_fin = false">
                Cancelar
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.dialog4.save(form.fecha_fin)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-checkbox label="Lunes" v-model="form.lunes"></v-checkbox>
        </v-col>
        <v-col>
          <v-checkbox label="Martes" v-model="form.martes"></v-checkbox
        ></v-col>
        <v-col
          ><v-checkbox label="Miércoles" v-model="form.miercoles"></v-checkbox
        ></v-col>
        <v-col
          ><v-checkbox label="Jueves" v-model="form.jueves"></v-checkbox
        ></v-col>
        <v-col
          ><v-checkbox label="Viernes" v-model="form.viernes"></v-checkbox
        ></v-col>
        <v-col
          ><v-checkbox label="Sábado" v-model="form.sabado"></v-checkbox
        ></v-col>
        <v-col
          ><v-checkbox label="Domingo" v-model="form.domingo"></v-checkbox
        ></v-col>
      </v-row>
    </v-card-text>
    <!-- <v-card-actions>
      <v-spacer />
      
      <v-btn
        v-if="producto_id != 0"
        color="blue darken-1"
        class="white--text"
        :loading="loading"
        :disabled="loading"
        @click="saveHorario"
      >
        Guardar
      </v-btn>
    </v-card-actions> -->
  </v-card>
</template>

<script>
import axios from "axios";
import EventBus from "../EventBus";
export default {
  props: {
    producto_id: {
      type: Number,
      default() {
        return 0;
      },
    },
    promocion: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      form: {
        id: 0,
        recurrente: false,
        diario: false,
        lunes: false,
        martes: false,
        miercoles: false,
        jueves: false,
        viernes: false,
        sabado: false,
        domingo: false,
        hora_inicio: null,
        hora_fin: null,
        fecha_inicio: null,
        fecha_fin: null,
        producto_id: this.producto_id,
      },
      error_input: {
        recurrente: "",
        diario: "",
        lunes: "",
        martes: "",
        miercoles: "",
        jueves: "",
        viernes: "",
        sabado: "",
        domingo: "",
        hora_inicio: "",
        hora_fin: "",
        fecha_inicio: "",
        fecha_fin: "",
      },
      loading: false,
      modal_fecha_inicio: false,
      modal_fecha_fin: false,
      modal_hora_inicio: false,
      modal_hora_fin: false,
    };
  },
  mounted() {
    if (this.promocion && this.promocion.id && this.promocion.id != 0) {
      this.form = this.promocion;
    }
  },
  methods: {
    saveHorario() {
      let urlTarget =
        0 == this.form.id
          ? "/api/productos/promociones/guardar"
          : `/api/productos/promociones/actualizar/${this.form.id}`;
      this.loading = true;

      axios
        .post(urlTarget, this.form)
        .then((response) => {
          let { data } = response;
          if (data.success) {
            EventBus.$emit("tugarrafon:show-snackbar", {
              color: "success",
              text_content: data.message,
            });

            this.$emit("save", data.message);
          }
        })
        .catch((error) => {
          EventBus.$emit("tugarrafon:show-snackbar", {
            color: "error",
            text_content: error.response.data.message,
          });
          if (error.response.status === 422) {
            this.error_input = Object.assign({}, error.response.data.data);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    form: {
      handler: function (val, oldVal) {
        console.log(val, oldVal);
        if (true === val.diario) {
          val.lunes = true;
          val.martes = true;
          val.miercoles = true;
          val.jueves = true;
          val.viernes = true;
          val.sabado = true;
          val.domingo = true;
        }
        if (true === val.recurrente) {
          val.fecha_inicio = null;
          val.fecha_fin = null;
        }
      },
      deep: true,
    },

    producto_id: {
      handler: function (val) {
        if (0 != this.producto_id) {
          this.form.producto_id = val;
        }
      },
    },
  },
};
</script>

<style>
</style>